import React, {
  Fragment,
  useEffect,
  useState,
  useContext,
  useRef,
} from "react";
import { Link } from "react-router-dom";
import styled, { css } from "styled-components";
import { Flex, Button, Line, Preloader0, Preloader } from './Uikit';
import { Appearer } from "./Appearer";
import { Product } from "./Product";
import { CSSgrid } from "./Catalog";
import { MetaContext } from "../context";

export const CatalogSection = React.memo((props) => {
  const context = useContext(MetaContext);
  const { first, highLightSection, type, oneGoal } = { ...props };

  const addToStack = context ? context.handles["addToStack"] : () => void 0;
  const checkIfInStack = context
    ? context.handles["checkIfInStack"]
    : () => void 0;
  const handleStack = context ? context.handles["handleStack"] : () => void 0;

  Array.prototype.diff = function (arr2, invert) {
    var ret = [];
    this.sort();
    arr2.sort();
    for (var i = 0; i < this.length; i += 1) {
      if (arr2.indexOf(this[i]) > -1 && !invert) {
        ret.push(this[i]);
      }
      if (arr2.indexOf(this[i]) === -1 && invert) {
        ret.push(this[i]);
      }
    }
    return ret;
  };

  // useEffect(() => {
  //   document.addEventListener("scroll", isInViewport);
  //   return () => {
  //     document.removeEventListener("scroll", isInViewport);
  //   }
  // }, [])

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            highLightSection(oneGoal["name"]);
          }
        });
      },
      { rootMargin: `0% 0% -80% 0%` }
    );
    viewElement.current && observer.observe(viewElement.current);
    return () => {
      viewElement.current && observer.unobserve(viewElement.current);
    };
  }, []);

  const filterSequential = (arr, currentSet, uniq) => {
    let a = [];
    if (!currentSet.length) return filterItems(arr, currentSet);

    if (!uniq)
      currentSet.forEach((one) => (a = [...a, ...filterItems(arr, [one])]));
    if (uniq)
      currentSet.forEach((one) => {
        let newA = [...filterItems(arr, [one])];
        newA = newA.diff(a, true);
        a = [...a, ...newA];
      });
    // a = filterItems(arr, currentSet)
    return a;
  };

  const filterItems = (arr, currentSet) => {
    return arr.filter(
      (oneSup) => !currentSet.length || oneSup[type].diff(currentSet).length
    );
  };

  const filterSecondary = (activeGoals) => {
    return context["data"]["supplements"]
      .filter((oneSup) => oneSup["secondary"].diff(activeGoals).length)
      .diff(filterItems(context["data"]["supplements"], activeGoals), true);
  };

  const CSSanchor = styled.div`
    position: absolute;
    margin-top: ${({ first }) => first ? "-200px" : "-2em"};
  `;

  const viewElement = useRef();

  return (
    <>
      {context && (
        <CSSsection ref={viewElement}>
          <CSSanchor id={oneGoal["name"]} first={first} />
          <Line>
            <Flex left top>
              <h1>{oneGoal["title"]}</h1>
            </Flex>
          </Line>

          <Line>
            <CSSdescr>{oneGoal["description"]}</CSSdescr>
          </Line>

          <Line lg>
            <Button
              style={{ marginTop: "0.4em" }}
              ghost
              sm
              onClick={() =>
                addToStack(
                  filterItems(context["data"]["supplements"], [
                    oneGoal["id"],
                  ]).map((item) => ({
                    id: item["id"],
                    useWhen: item["when"],
                  }))
                )
              }
            >
              Add all essential →
            </Button>
            &nbsp;&nbsp;&nbsp;
            <Button
              style={{ marginTop: "-0.3em" }}
              flat
              sm
              onClick={() => {
                addToStack([
                  ...filterItems(
                    context["data"]["supplements"],
                    [oneGoal["id"]],
                    "all"
                  ).map((item) => ({
                    id: item["id"],
                    useWhen: item["when"],
                  })),
                  ...filterSecondary([oneGoal["id"]]).map((item, i, arr) => ({
                    id: item["id"],
                    useWhen: item["when"],
                  })),
                ]);
              }}
            >
              Add all →
            </Button>
          </Line>

          {!Boolean(context['data']['supplements'].length) && <Preloader0 height={'200px'}><Preloader width={80} height={80}/></Preloader0>}


          {Boolean(context['data']['supplements'].length) && <CSSgrid>
            {filterItems(context["data"]["supplements"], [oneGoal["id"]]).map(
              (item, i) => {
                return (
                  <Appearer key={`product_${item["name"]}`} order={i}>
                    <Product
                      appearance="catalog"
                      active={checkIfInStack(item["id"])}
                      handle={() => handleStack(item["id"])}
                      data={item}
                    />
                  </Appearer>
                );
              }
            )}
          </CSSgrid>}

          <br />
          <br />

          <Line>
            <Flex left top>
              <h3>Secondary items</h3>
            </Flex>
          </Line>

          <CSSgrid width={140}>
            {filterSecondary([oneGoal["id"]]).map((item, i) => {
              return (
                <Appearer key={`product_secondary_${item["name"]}}`} order={i}>
                  <Product
                    appearance="catalog"
                    sm
                    active={checkIfInStack(item["id"])}
                    handle={() => handleStack(item["id"])}
                    data={item}
                  />
                </Appearer>
              );
            })}
          </CSSgrid>
        </CSSsection>
      )}
    </>
  );
});

const CSSdescr = styled.p`
  max-width: 720px;
  font-size: 1em;
  font-weight: 600;
  line-height: 1.5em;
  /* margin-top: 0.4em; */
  /* margin-bottom: 1.8em; */
  opacity: 0.6;
`;

const CSSsection = styled.div`
  display: relative;
  padding: 2em 0 4em 0;
  @media (max-width: 991px) {
    padding: 2em 0 2em 0;
  }
`;
